/**
 * Logikk for Department Risk Analysis
 * Klassifiserer risiko basert på terskelverdier fra flere indekser.
 */

export const RISK_LEVELS = {
  LOW: { label: 'Low Risk', color: 'emerald', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  MODERATE: { label: 'Moderate Risk', color: 'amber', bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  HIGH: { label: 'High Risk', color: 'orange', bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200' },
  CRITICAL: { label: 'Critical Risk', color: 'rose', bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' }
};

export const getDepartmentRisk = (metrics) => {
  const { we, stress, safety, conflict } = metrics;
  
  // Logikk: Hvis stress er ekstremt høyt eller trygghet ekstremt lav, er det kritisk uavhengig av snitt
  if (stress > 85 || safety < 30 || conflict > 80) return RISK_LEVELS.CRITICAL;
  if (we < 45 || stress > 75 || safety < 45) return RISK_LEVELS.HIGH;
  if (we < 65 || stress > 60 || safety < 60) return RISK_LEVELS.MODERATE;
  return RISK_LEVELS.LOW;
};

export const departmentData = [
  {
    id: 'd1',
    name: 'Utvikling',
    head: 'Sarah Chen',
    metrics: { we: 42, stress: 88, safety: 35, conflict: 25 },
    trends: [45, 44, 42, 40, 42],
    topRisks: ['Systemisk utbrenthet', 'Lav psykologisk trygghet', 'Uklare leveransekrav']
  },
  {
    id: 'd2',
    name: 'Salg',
    head: 'Morten Kraft',
    metrics: { we: 58, stress: 65, safety: 45, conflict: 78 },
    trends: [65, 62, 60, 58, 58],
    topRisks: ['Høyt konfliktnivå', 'Gnisninger i ledergruppen', 'Individuelt prestasjonspress']
  },
  {
    id: 'd3',
    name: 'Kundesupport',
    head: 'Linda Vang',
    metrics: { we: 72, stress: 55, safety: 68, conflict: 15 },
    trends: [68, 70, 71, 72, 72],
    topRisks: ['Emosjonell utmatting', 'Mangel på varierte oppgaver']
  },
  {
    id: 'd4',
    name: 'Administrasjon',
    head: 'Erik Jensen',
    metrics: { we: 85, stress: 30, safety: 92, conflict: 10 },
    trends: [82, 84, 85, 85, 85],
    topRisks: ['Silo-mentalitet']
  }
];

export const getDetailedInsights = (dept) => {
  const risk = getDepartmentRisk(dept.metrics);
  if (risk === RISK_LEVELS.CRITICAL || risk === RISK_LEVELS.HIGH) {
    return {
      status: "Behov for umiddelbar intervensjon",
      action: "Gjennomfør målrettet team-analyse og lederstøtte innen 7 dager.",
      priority: "Kritisk"
    };
  }
  return {
    status: "Stabil drift",
    action: "Fortsett med kvartalsvise pulsmålinger.",
    priority: "Normal"
  };
};